module.exports = __webpack_public_path__ + "img/default.09638ae4.png";